export default "__VITE_ASSET__CF$KEIMn__"